export enum CrusadeCardRanks {
   Newb = 0,
   Blooded = 1,
   BattleHardened = 2,
   Heroic = 3,
   Legendary = 4,
}

